import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

const AgentsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #e4e5e7;
  width: 100%;
  background-color: #e4e5e7;
  padding: 115px 0 0 60px;
  position: relative;
  top: -1px;
  margin-bottom: 55px;

  ${mediaMaxWidth.tablet} {
    padding: 115px 0 0 0;
  }
`;

export { AgentsWrapper as default };
